import React from 'react'
import { l } from '@manychat/manyui'

import { ContentContainer } from 'common/builder/components/chart/FlowChart/components/ContentContainer/ContentContainer'
import { NodeContainer } from 'common/builder/components/chart/FlowChart/components/Node/components/NodeContainer/NodeContainer'
import { NodeComponent } from 'common/builder/components/chart/FlowChart/components/Node/types'
import TextWithIcon from 'common/builder/components/chart/FlowChart/nodes/shared/TextWithIcon/TextWithIcon'
import { FlowChartNode } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartNode'

import { ContentWrapperStyle } from './Fallback.styles'

export const FallbackNode: NodeComponent<FlowChartNode> = (props) => {
  return (
    <NodeContainer
      container={props.container}
      builderId={props.builderId}
      disableFlowChartInteractions={props.disableFlowChartInteractions}
      nodeId={props.node.id}
    >
      <view style={ContentWrapperStyle}>
        <ContentContainer isEmpty>
          <TextWithIcon>
            {l.translate('Unkown node type: "{nodeType}"', { nodeType: props.node.type })}
          </TextWithIcon>
        </ContentContainer>
      </view>
    </NodeContainer>
  )
}
